<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HkgIPo/tc-custom/9781534325395.jpg?1705924466448" alt="This image is the cover for the book Bolero, Bolero"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bolero, Bolero
      </h1>
      <p class="bookDescription body article font2">
        <p>It’s Christmas in snowy Los Angeles, and Devyn “Dagger” Dagny is heartbroken. Her twelve-year relationship with her ex Natasha has just come to a tragic end, she’s an aimless college dropout floundering at her job, and now her best friend is getting married to the wrong guy. But what if she could start all over again? A mysterious stranger. Something called an “anti-door” and a “mother-key.” Only 53 chances. Eternal Sunshine of the Spotless Mind meets Locke and Key as writer WYATT KENNEDY and artist LUANA VECCHIO take you on an emotional journey across the multiverse. “Every so often, a book crosses your path that serves as both a burning reminder of what only comics can do and as a warning shot to the rest of the industry, putting all of us on notice. What KENNEDY and VECCHIO have created is a thrumming, heartfelt bravado story that defies genre even as it defies expectation. It is, genuinely, glorious. It is an overused phrase in an era of quick-copy and blurbs, but, in all sincerity, BOLERO is a must-read.” —GREG RUCKA Collects BOLERO #1-5</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Wyatt Kennedy, Luana Vecchio
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Image Comics
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?53321525